import { useLingui } from '@lingui/react/macro';
import _ from 'lodash';
import { getSportTypeLabel } from 'modules/core/domain/constants/sport-type-labels';
import { SportType } from 'modules/core/domain/enums/sport-type';
import { FocusEvent, ReactNode } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AppDispatch } from 'store/store';
import UDSearchInput from 'ud-ui/components/search';
import UDFormLabeledSelect from 'ud-form/components/labeled-select';
import { selectFilterByName, selectSortByDate } from 'modules/template-editor/store/templates/selectors';
import { setFilterByName, setSortByDate } from 'modules/template-editor/store/templates/templates';

interface CatalogHeaderProps {
  /** Кнопки справа от фильтров («Импортировать из файла» супер-админа). */
  actions?: ReactNode;
}

function Header({ actions }: CatalogHeaderProps) {
  const { t } = useLingui();
  const dispatch = useDispatch<AppDispatch>();
  const sortByDate = useSelector(selectSortByDate);
  const filterByName = useSelector(selectFilterByName);

  const searchInput = {
    label: t`Поиск по тексту:`,
    value: filterByName,
    placeholder: t`Название шаблона`,
    onChange: (event: FocusEvent<HTMLInputElement, Element>) => {
      dispatch(setFilterByName(event.target.value));
    },
  };

  const sortByDateOptions = [
    { value: 'none', label: t`Все` },
    { value: 'desc', label: t`Новые` },
    { value: 'asc', label: t`Старые` },
  ];
  const sortByData = {
    headerText: t`Сортировать по дате:`,
    options: sortByDateOptions,
    value: sortByDateOptions.find(({ value }) => value === sortByDate) ?? sortByDateOptions[0],
    onChange: (value: { label: string | number | JSX.Element; value: string } | undefined) => {
      const val = value?.value;
      if (val) {
        dispatch(setSortByDate(val as 'asc' | 'desc' | 'none'));
      }
    },
  };

  const sportTypes = _.keys(SportType).map((key) => {
    const label = getSportTypeLabel(key);
    return { value: key, label: _.capitalize(label ? t(label) : key) };
  });
  sportTypes.unshift({ value: 'all', label: t`Все` });
  const filterBySport = {
    headerText: t`Тип спорта:`,
    options: sportTypes,
    value: sportTypes.find(({ value }) => value === '') ?? sportTypes[0],
  };

  return (
    // The filters stay one row as before; only `actions` may wrap — where they do not fit beside the filters
    // (the super-admin's import button below ~1450px), they move to their own row instead of leaving the screen.
    <div className={'flex flex-wrap items-end'} style={{ columnGap: 20, rowGap: 12, marginTop: 18, paddingInline: 24 }}>
      {/* `min-w-0`: on a narrow screen the filters shrink as they did before the wrapper existed. */}
      <div className={'flex min-w-0'} style={{ gap: 20 }}>
        <UDSearchInput style={{ width: 451 }} iconPosition="icon-left" {...searchInput} />
        <UDFormLabeledSelect style={{ width: 171 }} {...sortByData} />
        <UDFormLabeledSelect disable={true} style={{ width: 200 }} {...filterBySport} />
      </div>
      {actions && <div className="ml-auto flex">{actions}</div>}
    </div>
  );
}

export default Header;
